export default __webpack_public_path__ + "static/media/safari-pinned-tab.72bc0a8d.svg";